function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(60.784314%,62.745098%,69.411765%)",
      fillOpacity: 1
    },
    d: "M 1 4.996094 C 1 3.894531 1.898438 3 3 3 L 21 3 C 22.105469 3 23 3.894531 23 4.996094 L 23 19.003906 C 23 20.105469 22.101562 21 21 21 L 3 21 C 1.894531 21 1 20.105469 1 19.003906 Z M 3 19.003906 L 21 19 C 21 19 21 4.996094 21 4.996094 L 3 5 C 3 5 3 19.003906 3 19.003906 Z M 8.027344 9.402344 C 8.273438 8.90625 8.714844 8.886719 9.007812 9.347656 L 10.707031 12.027344 C 11 12.492188 11.621094 12.628906 12.09375 12.335938 L 13.082031 11.722656 C 13.550781 11.429688 14.191406 11.554688 14.515625 12.007812 L 16.777344 15.183594 C 17.097656 15.636719 16.910156 16 16.359375 16 L 5.742188 16 C 5.1875 16 4.941406 15.597656 5.1875 15.105469 Z M 17.5 11 C 16.671875 11 16 10.328125 16 9.5 C 16 8.671875 16.671875 8 17.5 8 C 18.328125 8 19 8.671875 19 9.5 C 19 10.328125 18.328125 11 17.5 11 Z M 17.5 11 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoControl);
export default __webpack_public_path__ + "static/media/photo_control.c0c773daa5fcffe2fd62f31459e9ff7d.svg";
export { ForwardRef as ReactComponent };